export const SphereIcon = () => (
  <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="5.99375" cy="5.50156" r="5.4" fill="white" />
  </svg>
);
